import { CircleDashed } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const FormPendingSignatureBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-warning text-white">
      <CircleDashed />
      <span>{t('component:badge.formPendingSignature')}</span>
    </Badge>
  );
};
